import { useEffect, useState } from "react"

export const useLoadingText = (enabled: boolean, word: string = "Loading") => {
    const [dots, setDots] = useState(0)

    useEffect(() => {
        if (!enabled) return

        const timeout = setTimeout(
            () => setDots((dots) => (dots === 3 ? 0 : dots + 1)),
            dots < 3 ? 200 : 500
        )

        return () => {
            clearTimeout(timeout)
        }
    }, [dots, enabled])

    return word + ".".repeat(dots)
}
